
export const companyNameHeader = {
    headers: {
        'X-Requested-CompanyName': window.location.hostname,
    }
};
